import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import vuetify from "@/plugins/vuetify";
import { store } from "./store/store";
import "./plugins";
import "@/assets/scss/_global.scss";
Vue.config.productionTip = false;
import Toast from 'vue-toastification';
import 'vue-toastification/dist/index.css';
import 'font-awesome/css/font-awesome.css';


// plugin svgrender 
// import Vue plugin
import VueSvgInlinePlugin from "vue-svg-inline-plugin";

// import polyfills for IE if you want to support it
import "vue-svg-inline-plugin/src/polyfills";
// use Vue plugin without options
Vue.use(VueSvgInlinePlugin);

// use Vue plugin with options
VueSvgInlinePlugin.install(Vue, {
	attributes: {
		data: [ "src" ],
		remove: [ "alt" ]
	}
});

// end:: svgrender 

import VueSlickCarousel from 'vue-slick-carousel'
  import 'vue-slick-carousel/dist/vue-slick-carousel.css'
  // optional style for arrows & dots
  import 'vue-slick-carousel/dist/vue-slick-carousel-theme.css'
  import VueLazyload from 'vue-lazyload';

  const defaultImage = require("@/assets/images/Image_not_available.png");
  const loadingImage = require("@/assets/images/loading-gif.gif");
  Vue.component(VueSlickCarousel)
  Vue.component("VueSlickCarousel", VueSlickCarousel);
  import VueApexCharts from 'vue-apexcharts'
  Vue.use(VueApexCharts)
  Vue.use(VueLazyload,{
    preLoad: 1.3,  // Optionally configure preLoad ratio
    error: defaultImage,  // Placeholder image for errors
    loading: loadingImage,  // Placeholder while loading
    attempt: 1  // Number of attempts to load the image
  });
  Vue.use(Toast, {
    position: 'top-right',
    timeout: 5000,
    closeOnClick: true,
    pauseOnFocusLoss: true,
    pauseOnHover: true,
    draggable: true,
    draggablePercent: 0.6,
    showCloseButtonOnHover: false,
    hideProgressBar: false,
    closeButton: 'button',
    icon: true,
    rtl: false
  });

  Vue.component('apexchart', VueApexCharts)
new Vue({
  router,
  vuetify,
  store,
  render: h => h(App)
}).$mount("#app");
